<template>
    <div class="fengmian"  @click="goindex()">
<!-- 左滑进入 -->
<transition name="van-slide-down">
  <div v-show="visible" style="text-align: right;padding-right: 20px;margin-top:5%">
     <div>
        <img src="../assets/img2/yuanzhang.png" alt="" style="width:40%;">
     </div>
  </div>
</transition>

<transition name="van-slide-right">
  <div v-show="visible2" class="f6">
      <!-- <h3>院长寄语</h3> -->
      <img src="../assets/img2/1.png" style="width:80%;margin-top: 5%;">
  </div>
</transition>
<transition name="van-slide-right">
  <div v-show="visible3" class="f6">
      <!-- <h3>院长寄语</h3> -->
      <img src="../assets/img2/2.png" style="width:80%;">
  </div>
</transition>
<transition name="van-slide-right">
  <div v-show="visible4" class="f6">
      <!-- <h3>院长寄语</h3> -->
      <img src="../assets/img2/3.png" style="width:80%;">
  </div>
</transition>
<transition name="van-slide-right">
  <div v-show="visible5" class="f6">
      <!-- <h3>院长寄语</h3> -->
      <img src="../assets/img2/4.png" style="width:80%;">
  </div>
</transition>
<transition name="van-slide-up">
  <div v-show="visible6" class="f6">
      <!-- <h3>院长寄语</h3> -->
      <img src="../assets/img2/5.png" style="width:80%;margin-top: 14%;">
  </div>
</transition>
<!-- 右滑进入 -->
<!-- <transition name="van-slide-right">
  <div v-show="visible3" class="f6">
      <p>
            新一轮科技革命正席卷全球，汽车产业也
            进入了诞生以来最为深刻的变革期。作为
            市场规模全球第一的汽车大国，中国的汽
            车强国之路迎来了新的契机。自主创新、
            技术进步和产业转型已成为中国汽车产
            业可持续发展的首要课题。
        </p>
        
  </div>
</transition> -->
<!-- <transition name="van-slide-right">
  <div v-show="visible3" class="f6">
        <p>
            为促进汽车产业科技成果的有效转化，推动产
            业创新发展，清华大学苏州汽车研究院依托高
            校的技术与人才优势、地区的经济与区位优势，
            坚持“开放、合作、共享、创新”的方针，聚焦“绿
            色、智能、网联”三大主题，在布局自主研发的同
            时，广泛引进吸收国内外先进技术，培育了一批优
            秀的科研成果。
        </p>
  </div>
</transition> -->
<!-- <transition name="van-slide-right">
  <div v-show="visible3" class="f6">
        <p>
            《成果汇编》2014年策划成册，至今已是第四版。本
            版收录项目达112项，其中有30%的新培育项目首次与
            大家见面。希望以科技为媒，加深与行业内各专业领
            域专家读者的广泛交流合作，共同促进汽车产业的创新发展。
        </p>
       
  </div>
</transition> -->

    </div>
</template>
<script>
import $ from 'jquery'
import wx from 'weixin-js-sdk';
export default {
    name:'',
    data(){
        return{
            visible:false,
            visible1:false,
            visible2:false,
            visible3:false,
            visible4:false,
            visible5:false,
            visible6:false,
            text1:'',
            imgUrl:require("../assets/img2/lo.png"),
        }
    },
    created(){
        this.initWx();
    },
    mounted() {
        // this.a()
        var _this = this;
        var t1 = window.setTimeout(function() {
            _this.visible = true
        },500)
         var t3 = window.setTimeout(function() {
            _this.visible2 = true
            _this.visible3 = true
            _this.visible4 = true
            _this.visible5 = true
        },1200)
         var t4 = window.setTimeout(function() {
             _this.visible6 = true
        },1600)
      
    },
    methods:{
        goindex(){
            this.$router.push({path: '/home'})
        },
        a(){
            this.visible = true
        },
        initWx(){
      var _this = this
      var randNumber = Math.floor(Math.random() * 100000 + 1);
      var getWxData = '';
	    $.post(this.baseUrl+"/index.php/App/AjaxPublic/getWxData",{"request_url":window.location.href},function(res){
	     if(res.code == 1){
	    	 getWxData = res.data;
	    	 console.log(getWxData);
	    	 wx.config ({  
                 debug : false,    // true:调试时候弹窗  
                 appId : getWxData.appId,  // 微信appid  
                 timestamp : getWxData.timestamp, // 时间戳  
                 nonceStr : getWxData.nonceStr,  // 随机字符串  
                 signature :getWxData.signature, // 签名  
                 jsApiList : [  
                     // 所有要调用的 API 都要加到这个列表中  
                     'onMenuShareTimeline',   // 分享到朋友圈接口  
                     'onMenuShareAppMessage', //  分享到朋友接口  
                     'onMenuShareQQ',         // 分享到QQ接口  
                     'onMenuShareWeibo'       // 分享到微博接口  
                 ]  
             });  
             wx.ready (function () {  
                  // 微信分享的数据  
                  var shareData = {  
                    "imgUrl" :"http://project.tsinghua-auto.cn/Public/Xinwen/fenxiang/fenxiang.jpg?v="+randNumber,     // 分享显示的缩略图地址  
                     "link"  : window.location.href,// 分享地址  
                     "desc"  : "清华大学苏州汽车研究院最新技术成果展示",   // 分享描述  
                     "title" : "成果汇编",   // 分享标题  
                     success : function () {  

                      }   
                  };   
                    wx.onMenuShareTimeline (shareData);   
                    wx.onMenuShareAppMessage (shareData);   
                    wx.onMenuShareQQ (shareData);   
                    wx.onMenuShareWeibo (shareData);  
             });  
              
             wx.error(function(res){   
                //console.log(res);
                //alert(JSON.stringify(res));
             });  
	     }else{
         }
     },"JSON");  
    }
    }
}
</script>
<style scoped>
 .fengmian{
     width: 100%;
     background: #fff;
     padding-top: 10%
 }

 .dongdong{
     position: absolute;
     top: 50%;
     right: 20px;
 }
 .dongdong span{
    animation: rotatefresh 2s infinite linear;
    display: inline-block;
 }
.dongdong{
    float: left;
    width: 60px;height: 60px;
    animation: zy 2.5s .15s linear infinite;
    -moz-animation: zy 2.5s .15s linear infinite; /* Firefox */
    -webkit-animation: zy 2.5s 2.5s linear infinite; /* Safari and Chrome */
    -o-animation: zy 2.5s .15s linear infinite; /* Opera */
}
.dongdong img{
    height: 20px;
    width: 30px;
}
.f6{
    /* position: absolute;
    bottom: -4px;
    width: 100%;
    left: 25%; */
    padding-right: 15px;
    text-align: right;
    font-size: 0;
}
.f6 h3{
    font-size: 0.3rem;
}
.f6 p{
    font-size: 0.12rem;
}
.f4{
    position: absolute; 
    width: 100%;
    bottom: 13%;
    right: 0;
    text-align: right;
}
.fbtn{
    text-align: right;
}

.van-button{
    width: 50%;
    background-color: #e5efcc;
    border: 1px solid #257d43;
    font-size: 18px;
    box-shadow: 0px 4px 8px #a5a5a5;
}
</style>



// WEBPACK FOOTER //
// src/ivew/fengmian.vue